import React from 'react';
import NumberFormat from 'react-number-format';

const Estoque = (props) => {
    let {unMedida, value} = props;
    
    
    return <NumberFormat 
        decimalScale={4}
        thousandSeparator="."
        decimalSeparator=","
        suffix={unMedida}
        fixedDecimalScale={false}
        displayType={'text'}
        defaultValue="0"
        
        value={value}
        {...props}></NumberFormat>
}

export {Estoque};